module.exports = __webpack_public_path__ + "img/income.26c8434d.svg";